import { AssociateInfo } from '@amzn/atoz-shiftapp-types';

export const getAssociateInfo = (): AssociateInfo => {
    const APP_ROOT = document.getElementById('atoz-shift-management-page-root');
    const dataset = APP_ROOT?.dataset;

    return {
        employeeId: dataset?.employeeId || '',
        locale: dataset?.locale || 'en-US',
        siteId: dataset?.siteId || '',
        timeZone: dataset?.timeZone || '',
        associateName: dataset?.associateName || ''
    };
};
